import { faArrowTurnDownLeft } from "@fortawesome/pro-regular-svg-icons";
import { useEffect, useRef } from "react";
import { twJoin } from "tailwind-merge";

import { Button } from "src/base-components/Button";

type Props = {
  value: string;
  disabled: boolean;
  minified: boolean;
  onChange: (value: string) => void;
  onSubmit: () => void;
};

export const PromptBox: React.FC<Props> = ({
  disabled,
  value,
  minified,
  onChange,
  onSubmit,
}) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  useEffect(() => {
    const textArea = textAreaRef.current;
    if (textArea) {
      // reset the height momentarily to get correct scrollHeight
      textArea.style.height = "0px";
      const scrollHeight = Math.min(textArea.scrollHeight + 2, 60); // +2 here avoid scroll on 2 lines of text
      textArea.style.height = `${scrollHeight}px`;
    }
  }, [value]);

  return (
    <form onSubmit={handleSubmit}>
      <div className="broder-gray-200 relative flex flex-col rounded-lg border bg-gray-0 shadow-sm">
        <textarea
          ref={textAreaRef}
          className={twJoin(
            "resize-none",
            "border border-transparent",
            "pb-2.5 pl-3 pt-2",
            "text-gray-500 font-inter-normal-13px",
            "focus:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/25",
            minified ? "rounded-lg" : "rounded-t-lg",
            minified ? "pr-24" : "pr-3",
          )}
          placeholder={minified ? "Reply to Copilot..." : "Message Copilot..."}
          rows={1}
          value={value}
          required
          onChange={(e) => onChange(e.target.value)}
        />
        {minified && (
          <div className="absolute right-2 top-2">
            <Button
              disabled={disabled}
              htmlType="submit"
              iconRight={faArrowTurnDownLeft}
              size="sm"
              variant="primary"
            >
              Continue
            </Button>
          </div>
        )}
        {!minified && (
          <div className="mx-3 flex items-center justify-between border-t border-t-gray-100 py-2">
            <p className="text-gray-500 font-inter-normal-12px">
              Use @ to refer to other nodes
            </p>
            <Button
              disabled={disabled}
              htmlType="submit"
              iconRight={faArrowTurnDownLeft}
              size="sm"
              variant="primary"
            >
              Start Chat
            </Button>
          </div>
        )}
      </div>
    </form>
  );
};
